<template>
  <div class="traditional-header-navigation tw-bg-white">
    <v-container class="tw-flex tw-items-center tw-pt-6 tw-pb-0">
      <a :href="domain">
        <v-img src="https://legacy.igws.indiana.edu/images/IGWS_Logo.svg" max-width="175" contain class="tw-ml--4" />
      </a>
    </v-container>
    <v-app-bar
               height="56"
               flat
               class="tw-sticky tw-top-0 tw-z-10 tw-border-b-4 tw-border-gray-200 tw-bg-white">
      <v-container class="tw-flex tw-items-center tw-h-full tw-py-0">
        <h1 class="text-h6 tw-whitespace-no-wrap tw-text-gray-800">Indiana Water Balance Network</h1>
        <v-spacer />
        <traditional-header-navigation-tabs />


        <div class="dropdown">
          <button class="dropbtn">Data</button>
          <div class="dropdown-content">
            <a target="_blank" href="https://legacy.igws.indiana.edu/water/api_doc#/">Download</a>
            <a target="_blank" href="https://ag.purdue.edu/indiana-state-climate/data/indiana-mesonet/">Indiana Mesonet of Mesonets</a>
          </div>
        </div>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
import TraditionalHeaderNavigationTabs from '@/components/layouts/TraditionalHeaderNavigationTabs'
export default {
  name: 'TraditionalNavigation',
  components: { TraditionalHeaderNavigationTabs },
  data () {
    return {
      domain: process.env.VUE_APP_DOMAIN
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
